require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

/**
 * @func 诸葛埋点
 * @Author zhangfs
 * @lastEditor zhangfs
 */

/**
 * @func 接入前须知
 * 在获取用户信息接口之后，设置用户实名访问：window.zhuge.identify()
 */
window.zhuge = window.zhuge || [];
window.zhuge.methods = '_init identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(' ');

window.zhuge.factory = function (b) {
  return function () {
    var a = Array.prototype.slice.call(arguments);
    a.unshift(b);
    window.zhuge.push(a);
    return window.zhuge;
  };
};

for (var i = 0; i < window.zhuge.methods.length; i++) {
  var key = window.zhuge.methods[i];
  window.zhuge[key] = window.zhuge.factory(key);
}

window.zhuge.load = function (b, x) {
  if (!document.getElementById('zhuge-js')) {
    var a = document.createElement('script');
    var verDate = new Date();
    var verStr = verDate.getFullYear().toString() + verDate.getMonth().toString() + verDate.getDate().toString();
    a.type = 'text/javascript';
    a.id = 'zhuge-js';
    a.async = !0;
    a.src = process.env.VUE_APP_ZHUGE_URL + verStr;

    a.onerror = function () {
      try {
        window.zhuge.identify = window.zhuge.track = function (ename, props, callback) {
          if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
            callback();
          } else if (Object.prototype.toString.call(props) === '[object Function]') {
            props();
          }
        };
      } catch (error) {
        console.log('ZHUGE_INIT_TRACK_ERROR', error);
      }
    };

    try {
      var c = document.getElementsByTagName('script')[0];
      c && c.parentNode.insertBefore(a, c);

      window.zhuge._init(b, x);
    } catch (error) {
      console.log('ZHUGE_INIT_ERROR:', error);
    }
  }
};

try {
  window.zhuge.load(process.env.VUE_APP_ZHUGE_KEY, {
    debug: process.env.VUE_APP_MODE !== 'prod',
    superProperty: {
      '应用名称': 'IDM'
    },
    autoTrack: true,
    singlePage: true
  });
} catch (error) {
  console.log('ZHUGE_LOAD_ERROR:', error);
}